import { Utils } from './utils';
import { forceCloseHamburger } from './animation';

// ================================================================
// スクロール関連機能
// ================================================================

// -----------------------------------------------
// ヘッダー表示制御
// -----------------------------------------------
export function initHeaderVisibility() {
  const header = document.querySelector('.js-header');
  
  if (!header) {
    return;
  }

  if (typeof ScrollTrigger === 'undefined') {
    console.warn('ScrollTrigger is not loaded');
    return;
  }

  try {
    ScrollTrigger.create({
      trigger: 'body',
      start: 'top top-=100',
      end: 'bottom bottom',
      markers: false,
      toggleClass: { targets: '.js-header', className: 'is-visible' },
      onEnter: () => header.classList.add('is-visible'),
      onLeaveBack: () => header.classList.remove('is-visible'),
    });
  } catch (error) {
    console.error('Failed to initialize header visibility:', error);
  }
}

// -----------------------------------------------
// スムーズスクロール
// -----------------------------------------------
export function initSmoothScroll() {
  const anchors = document.querySelectorAll('a[href*="#"]');
  
  if (!anchors.length) {
    return;
  }

  anchors.forEach((anchor) => {
    // 目次プラグインのアンカーの場合はスキップ
    if (anchor.closest('#ez-toc-container')) {
      return;
    }

    anchor.addEventListener('click', (event) => {
      if (Utils.isInPageLink(event)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        
                // ドロワーが開いている場合は強制的に閉じる
        forceCloseHamburger();
        
        Utils.movePosition(event.currentTarget);
      }
    });
  });
}

// -----------------------------------------------
// CTAポップアップ制御
// -----------------------------------------------
/**
 * ポップアップを非表示にする必要があるページかどうかを判定
 * 今後対象ページが増える場合は、この関数内の条件を追加する
 * @returns {boolean} トップで非表示にする必要があるページの場合true
 */
function shouldHidePopupAtTop() {
  // トップページの判定
  const isTopPage = document.body.classList.contains('home') || 
                    document.body.classList.contains('front-page') ||
                    window.location.pathname === '/' ||
                    window.location.pathname === '/index.php';

  // サービスページの判定
  const isServicePage = document.querySelector('[id^="service-"]') !== null;

  // 今後対象ページが増える場合は、ここに条件を追加
  // 例: const isCustomPage = document.body.classList.contains('custom-page');

  return isTopPage || isServicePage;
}

export function initCtaPopup() {
  const popup = document.querySelector('.js-cta-popup');
  const ctaContact = document.querySelector('.js-cta-contact');

  if (!popup) {
    return;
  }

  // スクロール位置を取得
  const getScrollY = () => window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
  // iPhone実機での誤差を考慮して、10px以下をトップと判定
  const isAtTop = () => getScrollY() < 10;

  // CTAセクションに入っているか判定
  const isInCtaSection = () => {
    if (!ctaContact) {
      return false;
    }
    const ctaRect = ctaContact.getBoundingClientRect();
    const scrollY = getScrollY();
    const ctaTop = scrollY + ctaRect.top;
    const viewportBottom = scrollY + window.innerHeight;
    // ビューポートの下端がCTAセクションの上端を通過しているか
    return viewportBottom >= ctaTop;
  };

  // ポップアップの表示/非表示を制御
  const updatePopupVisibility = () => {
    // CTAセクション以降にいる場合は非表示
    if (isInCtaSection()) {
      popup.classList.remove('is-visible');
      return;
    }
    // ページトップの場合（トップページ・サービスページのみ）
    if (isAtTop() && shouldHidePopupAtTop()) {
      popup.classList.remove('is-visible');
      return;
    }
    // それ以外は表示
    popup.classList.add('is-visible');
  };

  // スクロールイベント処理
  let ticking = false;
  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updatePopupVisibility();
        ticking = false;
      });
      ticking = true;
    }
  };
  window.addEventListener('scroll', handleScroll, { passive: true });

  // 初期表示
  updatePopupVisibility();
} 